import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
} from "@mui/material";
import { FirmaElectronicaComponent } from "components/componentesGenerales/firmaElectronica";
import { AlertInfo } from "components/demandaEnLineaComponents/alertInfo";
import { Firmante } from "components/demandaEnLineaComponents/components/firmante";
import { IconContext } from "react-icons";
import { FaFileSignature } from "react-icons/fa";
import {
  postDerFimaElectronica,
  postFirmaArchivosExtendidos,
  postTerminarFirmaAnticipada,
  postValidarStatusSign,
  postVector,
} from "services/firmaElectronicaServices/firmaElectronicaServices";
import { tiposDocumentosFirmas } from "static/_firmaElectronicaData";
import { red } from "@mui/material/colors";
import { useSolicitudesFirmaStore } from "hooks/useSolicitudesFirmaStore";

export const FirmaElectronica = () => {
  const { solicitudFirma } = useSolicitudesFirmaStore();

  return (
    <>
      <FirmaElectronicaComponent
        idsReferencias={[
          Number(solicitudFirma?.idSolicitudDemanda) ||
            Number(solicitudFirma?.idSolicitudActuacion),
        ]}
        cveTipoDocumentoFirma={
          solicitudFirma?.idSolicitudDemanda
            ? tiposDocumentosFirmas.DEMANDA_ELECTRONICA
            : tiposDocumentosFirmas.PROMOCION_ELECTRONICA
        }
        extraParams={{
          idActuacion: 1,
          cveTipoDocumentoFirma: solicitudFirma?.idSolicitudDemanda
            ? tiposDocumentosFirmas.DEMANDA_ELECTRONICA
            : tiposDocumentosFirmas.PROMOCION_ELECTRONICA,
          cveAdscripcion: 1,
          cveGrupo: 1,
          cveSistema: 2,
          anticipada: "S",
          modeloGestion: "N",
          generarPdf: "N",
          debugg: 1,
        }}
        validarStutusSignService={postValidarStatusSign}
        derService={postDerFimaElectronica}
        vectorService={postVector}
        firmaArchivosExtendidosService={postFirmaArchivosExtendidos}
        terminarFirmaAnticipadaService={postTerminarFirmaAnticipada}
        enlaceInvitado={true}
        solicitudFirma={solicitudFirma}
      >
        {({ statusFirma }) => {
          return (
            <>
              <Card
                className="w-full lg:w-[92%] xl:w mx-auto"
                sx={{
                  borderRadius: "10px",
                  paddingY: "24px",
                  boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
                }}
              >
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                      3
                    </Avatar>
                  }
                  title="Proporciona los datos de la firma electronica"
                />
                <Divider />
                <CardContent>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <AlertInfo
                        title={`Cuando se firma de manera correcta el(los) documento(s), aparecerá un botón para Enviar Demanda.`}
                        subtitle={
                          "  Una vez enviada(s) la demanda aparecerá un botón de Acuse, el cual al hacer clic mostrará el(los) documento(s) firmados."
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FirmaElectronicaComponent.ErrorMessage />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Firmante statusFirma={statusFirma} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FirmaElectronicaComponent.Cer disabled={false} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FirmaElectronicaComponent.Key disabled={false} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FirmaElectronicaComponent.Password
                            size="small"
                            disabled={false}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <FirmaElectronicaComponent.Firmantes />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Box className="flex justify-end  flex-wrap w-full">
                    <Box>
                      <FirmaElectronicaComponent.Option
                        label="Firmar Documento"
                        variant="contained"
                        color="error"
                        type="submit"
                        sx={{
                          marginTop: "10px",
                          marginRight: {
                            xs: "0px",
                            sm: "0px",
                            md: "10px",
                            lg: "10px",
                            xl: "10px",
                          },
                        }}
                        className="w-full sm:w-full md:w-auto lg:w-auto xl:w-auto"
                        startIcon={
                          <IconContext.Provider
                            value={{ className: "text-2xl" }}
                          >
                            <FaFileSignature />
                          </IconContext.Provider>
                        }
                      />
                    </Box>
                  </Box>
                </CardActions>
              </Card>
            </>
          );
        }}
      </FirmaElectronicaComponent>
    </>
  );
};
